import React from "react";

export default function CompanyHeader({ data: c }) {
    return (
        <div className="">
            <header
                className="position-relative text-white pt-3"
                style={{
                    background: `linear-gradient(rgba(0,0,0,.60),rgba(0,0,0,.60)), url(${c.logo}) center/cover`,
                    minHeight: "220px",
                }}
            >
                <div className="container d-flex flex-column justify-content-end h-100 pb-3">
                    <img
                        src={c.logo}
                        alt={c.name}
                        className="rounded-circle border border-3 border-white mb-2"
                        width={72}
                        height={72}
                        style={{ objectFit: "cover" }}
                    />
                    <h1 className="fw-bold mb-1 lh-1">{c.name}</h1>
                    <p className="mb-1 small text-white">{c.address}</p>
                    <a
                        href={`https://www.google.com/maps/search/${encodeURIComponent(
                            c.name + " " + c.address
                        )}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn bg-primary btn-sm fw-bold text-white"
                    >
                        <i className="bi bi-geo-alt-fill me-1" />
                        Navigate
                    </a>
                </div>
            </header>

            <div className="bg-primary shadow">
                <div className="container d-flex justify-content-around py-2">
                    <Action icon="phone" label="Call" href={`tel:${c.contact}`}/>
                    <Action
                        icon="mail"
                        label="Mail"
                        href={`mailto:${c.mail}`}
                    />
                    <Action
                        icon="event"
                        label="Book"
                        href={`tel:${c.contact}`}
                    />
                    <Action
                        icon="qr_code_scanner"
                        label="Table-QR"
                        href={`tel:${c.contact}`}
                    />
                </div>
            </div>
        </div>
    );
}

function Action({ icon, label, href }) {
    return (
        <a
            href={href}
            className="d-flex flex-column align-items-center text-white text-decoration-none"
            style={{ width: 64 }}
        >
            <i className="material-icons">{icon}</i>
            <small className="fw-semibold">{label}</small>
        </a>
    );
}